import APIService from "@/services/APIService.js";

export default {
    getAgendamentosAutomaticos() {
        return APIService.apiCall().get("/AgendamentosAutomaticos/getAgendamentosAutomaticos");
    },
    
    salvarItem(postData) {
        return APIService.apiCall().post(`/AgendamentosAutomaticos/salvar`, JSON.stringify(postData));
      },
}